const formatNumberToTwoDigit = (n: number): string => {
  return n > 9 ? n.toString() : `0${n}`;
};

export const clientDateToServerDate = (inputDate: Date): Date | undefined => {
  if (!inputDate) {
    return undefined;
  }
  return new Date(
    Date.UTC(
      inputDate.getUTCFullYear(),
      inputDate.getUTCMonth(),
      inputDate.getUTCDate(),
      0,
      0,
      0,
      0
    )
  );
};

export const clientDateToServerDateTime = (
  inputDate: Date
): Date | undefined => {
  if (!inputDate) {
    return undefined;
  }
  return new Date(
    Date.UTC(
      inputDate.getUTCFullYear(),
      inputDate.getUTCMonth(),
      inputDate.getUTCDate(),
      inputDate.getUTCHours(),
      inputDate.getUTCMinutes(),
      inputDate.getUTCSeconds(),
      inputDate.getUTCMilliseconds()
    )
  );
};

export const clientDateToServerDateString = (
  inputDate?: Date
): string | undefined => {
  if (!inputDate) {
    return undefined;
  }
  return `${inputDate.getFullYear()}-${formatNumberToTwoDigit(
    inputDate.getMonth() + 1
  )}-${formatNumberToTwoDigit(inputDate.getDate())}`;
};
